// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__2Fo0n","center":"Dashboard_center__klsco"};